import { inject, provideAppInitializer } from '@angular/core';
import { Router, UrlSerializer } from '@angular/router';
import { CookieService, PlatformService } from 'ngx-unificator/services';

export const provideRestrictRedirect = () => {
  return [
    provideAppInitializer(async () => {
      const platform = inject(PlatformService);
      const router = inject(Router);
      const cookie = inject(CookieService);
      const serializer = inject(UrlSerializer);
      if (platform.isBrowser) {
        const params = serializer.parse(window?.location?.search).queryParams;
        if ((cookie.check('id_id') || cookie.check('registered')) && !cookie.check('restrict')) {
          return;
        }
        if (cookie.check('restrict')) {
          clearWorker();
          setTimeout(() => {
            router.navigateByUrl('/403');
          }, 500);
          return;
        }
        if (params.hasOwnProperty('restrict')) {
          clearWorker();
          setTimeout(() => {
            cookie.set('restrict', '1', 1, '/');
            router.navigateByUrl('/403');
          }, 500);
        }
      }
    }),
  ];
};

async function clearWorker() {
  if ('serviceWorker' in navigator && 'caches' in window) {
    await navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => {
        for (const registration of registrations) {
          registration
            .unregister()
            .then((success) => {
              console.log('Unregister old worker - ' + success);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      })
      .catch((error) => {
        console.log(error);
      });

    await caches
      .keys()
      .then((cacheNameList) => {
        cacheNameList.forEach((cacheName) => {
          caches.delete(cacheName);
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }
}
